import { useCallback } from 'react'
import { setAllMainSelection } from '@/atoms'

export function useSelectOrderSteps(orderStepIds: string[]) {
  return useCallback(
    () => setAllMainSelection({ orderSteps: orderStepIds, routes: [] }),
    [orderStepIds],
  )
}
